import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * [refCallback, height] — height (px) of the element the callback is attached to, kept up to
 * date with ResizeObserver (0 without layout, e.g. in jsdom). Works for elements that mount later.
 */
export default function useElementHeight() {
  const [height, setHeight] = useState(0);
  const cleanup = useRef(null);
  const ref = useCallback((el) => {
    if (cleanup.current) {
      cleanup.current();
      cleanup.current = null;
    }
    if (!el) return;
    const measure = () => {
      const h = Math.round(el.getBoundingClientRect().height || 0);
      setHeight((prev) => (prev === h ? prev : h));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure);
      cleanup.current = () => window.removeEventListener('resize', measure);
    } else {
      const ro = new ResizeObserver(measure);
      ro.observe(el);
      cleanup.current = () => ro.disconnect();
    }
  }, []);
  useEffect(() => () => cleanup.current?.(), []);
  return [ref, height];
}
